import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  standalone: false
})
export class ErrorPageComponent {
  private router = inject(Router);
  public translate = inject(TranslateService);

  currentRoute: string;
  title!: string;
  message!: string;

  constructor() {
    this.currentRoute = this.router.url;
    this.setErrorMessage();
  }

  private setErrorMessage(): void {
    if (this.currentRoute === '/404') {
      this.title = this.translate.instant('errorPage.404.title');
      this.message = this.translate.instant('errorPage.404.message');
    } else {
      this.title = this.translate.instant('errorPage.server.title');
      this.message = this.translate.instant('errorPage.server.message');
    }
  }

  goHome(): void {
    this.router.navigate(['/'], { replaceUrl: true });
  }
}
